// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"7a203be9","455":"ee22c782","977":"4ca640bf"}[chunkId] + ".chunk.js";
};